export default {
	"Order.NoProductsSelected": "未选择商品",
	"Order.prompt": "提示",
	"Order.UntieTheBindingForTheTimeBeing": "暂不解绑",
	"Order.UnbindTheAccount": "解绑账号",
	"Order.SorryFailedToCreateOrder": "抱歉，创建订单失败！",
	"Order.RepeatPurchasePrompts": "重复购买提示",
	"Order.ignore": "忽略",
	"Order.ViewOrders": "查看订单",
	"Order.WeChatCanEnterTheAccessAfterAuthorizationRequestAuthorization": "微信授权后可进入访问，请求授权中···",
	"Order.GotIt": "知道了",
	"Order.PleaseRedeemItInWeChatOrCallAPP": "请在微信或【叫叫】APP内进行兑换",
	"Order.ToPayForThisOrderPleasePayInTheOrderLogisticsOfTheCallPublicAccount": "支付该订单请在【叫叫】公众号的订单物流中进行支付"
}